import {
  RemoteExportAcademicManagementReport,
  RemoteGetAcademicManagementReport,
} from 'data/usecases';
import {
  ExportAcademicManagementGroups,
  ExportAcademicManagementInternshipLocations,
  ExportAcademicManagementProfessionals,
  ExportAcademicManagementTasks,
  GetAcademicManagementGroups,
  GetAcademicManagementInternshipLocations,
  GetAcademicManagementProfessionals,
  GetAcademicManagementTasks,
} from 'domain/usecases';
import {
  makeApiUrlAcademicManagementGroups,
  makeApiUrlAcademicManagementGroupsExportExcel,
  makeApiUrlAcademicManagementInternshipLocations,
  makeApiUrlAcademicManagementInternshipLocationsExportExcel,
  makeApiUrlAcademicManagementProfessionals,
  makeApiUrlAcademicManagementProfessionalsExportExcel,
  makeApiUrlAcademicManagementTasks,
  makeApiUrlAcademicManagementTasksExportExcel,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAcademicManagementGroups =
  (): GetAcademicManagementGroups =>
    new RemoteGetAcademicManagementReport(
      makeApiUrlAcademicManagementGroups(),
      makeAxiosHttpClient(),
    );

export const makeGetAcademicManagementTasks = (): GetAcademicManagementTasks =>
  new RemoteGetAcademicManagementReport(
    makeApiUrlAcademicManagementTasks(),
    makeAxiosHttpClient(),
  );

export const makeGetAcademicManagementInternshipLocations =
  (): GetAcademicManagementInternshipLocations =>
    new RemoteGetAcademicManagementReport(
      makeApiUrlAcademicManagementInternshipLocations(),
      makeAxiosHttpClient(),
    );

export const makeGetAcademicManagementProfessionals =
  (): GetAcademicManagementProfessionals =>
    new RemoteGetAcademicManagementReport(
      makeApiUrlAcademicManagementProfessionals(),
      makeAxiosHttpClient(),
    );

export const makeExportAcademicManagementGroups =
  (): ExportAcademicManagementGroups =>
    new RemoteExportAcademicManagementReport(
      makeApiUrlAcademicManagementGroupsExportExcel(),
      makeAxiosHttpClient(),
    );

export const makeExportAcademicManagementTasks =
  (): ExportAcademicManagementTasks =>
    new RemoteExportAcademicManagementReport(
      makeApiUrlAcademicManagementTasksExportExcel(),
      makeAxiosHttpClient(),
    );

export const makeExportAcademicManagementInternshipLocations =
  (): ExportAcademicManagementInternshipLocations =>
    new RemoteExportAcademicManagementReport(
      makeApiUrlAcademicManagementInternshipLocationsExportExcel(),
      makeAxiosHttpClient(),
    );

export const makeExportAcademicManagementProfessionals =
  (): ExportAcademicManagementProfessionals =>
    new RemoteExportAcademicManagementReport(
      makeApiUrlAcademicManagementProfessionalsExportExcel(),
      makeAxiosHttpClient(),
    );
